import { Invoice } from '@features/invoicesLegacy/types/invoice'
import { InvoiceType } from '@features/invoicesLegacy/types/invoiceType'

import { PayableSubject } from '../types'

export const isSubjectInvoice = (subject: PayableSubject): subject is Invoice => {
  return subject.type === InvoiceType.Invoice || 'invoiceNo' in subject
}
